module.exports = __webpack_public_path__ + "img/tiny.c15db576.svg";